// import types from '../types'
import Helpers from '../Helpers'

export const breakCode = () => (dispatch, getState) => {
  const uid = getState().userReducer?.user?.uid || ''
  const data = {
    uid,
  }
  Helpers.fetchPostJson(process.env.REACT_APP_ATLS + 'code', data, data)
      .then((res) => {
        console.log(res)
      })
}
